import { render } from "./SceltaVeicolo.vue?vue&type=template&id=caa9a8d2&scoped=true"
import script from "./SceltaVeicolo.vue?vue&type=script&lang=js"
export * from "./SceltaVeicolo.vue?vue&type=script&lang=js"

import "./SceltaVeicolo.vue?vue&type=style&index=0&id=caa9a8d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa9a8d2"]])

export default __exports__